let uploadedCoverFile = [];
let uploadedCoverFile2 = [];
let cover_post_list = '';
let coverInchToPx = 300;
let coverCmToPx = 120;
var cover_picker;

//var albumCoverHeightPx = 3071;
//var albumCoverWidthPx = 2421;




/*
var $n = jQuery.noConflict();
$n("body").on('change', '.dd_1045850_426629', function(e){
  alert('jest:');
});  
*/





var $j = jQuery.noConflict();
$j(document).ready(function() { 
  /*
    if( $j( "#mango_photopanel_upload_file_width" ).val() == '6' ) {  albumCoverHeightPx = 2481; albumCoverWidthPx =1832; }
    if( $j( "#mango_photopanel_upload_file_width" ).val() == '8' ) {  albumCoverHeightPx = 3071; albumCoverWidthPx =2421; }
    if( $j( "#mango_photopanel_upload_file_width" ).val() == '10' ) {  albumCoverHeightPx = 3661; albumCoverWidthPx = 3012; }
    if( $j( "#mango_photopanel_upload_file_width" ).val() == '12' ) {  albumCoverHeightPx = 4252; albumCoverWidthPx = 3602; }   
*/
    if( ($j("#mango_photopanel_upload_file_width").val() === '6') && ($j("#mango_photopanel_upload_file_height").val() === '6') ) {  var albumCoverHeightPx = 2481; var albumCoverWidthPx =1832; }
    else if( parseInt($j("#mango_photopanel_upload_file_width").val()) === 8 && parseInt($j("#mango_photopanel_upload_file_height").val()) === 8 ) {  var albumCoverHeightPx = 3071; var albumCoverWidthPx =2421; }
    else if( parseInt($j("#mango_photopanel_upload_file_width").val()) === 10 && parseInt($j("#mango_photopanel_upload_file_height").val()) === 10 ) {  var albumCoverHeightPx = 3661; var albumCoverWidthPx = 3012; }
    else if( parseInt($j("#mango_photopanel_upload_file_width").val()) === 12 && parseInt($j("#mango_photopanel_upload_file_height").val()) === 12 ) {  var albumCoverHeightPx = 4252; var albumCoverWidthPx = 3602; }  
    else if( parseInt($j("#mango_photopanel_upload_file_width").val()) === 12 && parseInt($j("#mango_photopanel_upload_file_height").val()) === 8 ) {  var albumCoverHeightPx = 3071; var albumCoverWidthPx = 3602; }  
    else if( parseInt($j("#mango_photopanel_upload_file_width").val()) === 8 && parseInt($j("#mango_photopanel_upload_file_height").val()) === 12 ) {  var albumCoverHeightPx = 4252; var albumCoverWidthPx = 2421; }    
   
  
	$j("body").on('change', '.mango-photopanel-cover-uploader-wrapper #step-2-confirmation input[type="checkbox"]', function(e){
		var checked = $j(this).prop('checked');
		if(checked == true) {
			$j(".mango-photopanel-cover-uploader-wrapper #go-to-finish").show();
		} else {	
			$j(".mango-photopanel-cover-uploader-wrapper #go-to-finish").hide();
		}   
    });  
  	$j(".mango-photopanel-cover-uploader-wrapper #go-to-finish").click(function(){
		finishCoverUploader();
    });  
    $j("body").on('click', ".mango-photopanel-cover-uploader-wrapper button.close", function(e){
		closeCoverUploader();    
    });
    $j("body").on('click', ".mango-photopanel-cover-uploader-wrapper button.close2", function(e){
		closeCoverPreview();    
    });  
    $j("body").on('click', ".mango-photopanel-cover-uploader-wrapper #step-2-cancel", function(e){
		closeCoverUploader();
    });  


    $j("#btn-remove-files").click(function(){
		$j("#file-upload-show-spreads-btn").hide();           
		$j("#file-upload-show-btn").show();    
		closePreview();         
		$j( "#mango-uploader-files" ).val('');
		$j( "#mango-uploader-files-names" ).val('');     
        $j( "#mango-uploader-preview-slider2 .item" ).remove();    
        $j("#message-no-uploader-files").show();        
    });



    $j("#file-photopanel-cover-upload-show-btn").click(function(){
        $j( "#mango-photopanel-cover-uploader-preview-order .item" ).remove();        
        $j( "#mango-photopanel-cover-uploader-preview-slider .item" ).remove();  
        $j( "#mango-photopanel-cover-uploader-preview-slider2 .item" ).remove();        
        $j(".label-album-size").text(albumCoverWidthPx + 'x' + albumCoverHeightPx);      
     
		const cover_filestack_client = filestack.init('AbkDGv2FYSHi0mxqhYMgQz'); 
        const cover_options = {
        	displayMode: 'inline',
        	container: '#coverdroppane',    
  			accept: ["image/jpeg", "image/jpg"],          
			fromSources: ["local_file_system","googledrive","onedrive"],
			exposeOriginalFile: true,          
          	maxFiles: 1,
          	minFiles: 1,          
            transformations: {
               crop: {
                    aspectRatio: albumCoverWidthPx/albumCoverHeightPx,
                    force: true
                },
           		circle: false,
           	 	rotate: false
            },
			customText: {                     
        		'Our file upload limit is {maxFiles} {filesText}': 'You selected the wrong number of files. The number of files must be equal to the number of spreads selected.'
            },
            onFileUploadFinished: function(file) {
//		console.log(file);              
				uploadedCoverFile.push(file["url"]);
				uploadedCoverFile2.push(file["filename"] +'^'+file["handle"]);          
            },          
       	 	onUploadDone: function(){
              	uploadedCoverFile2.sort();
   				uploadCoverFinished(uploadedCoverFile2);
              	// send tokens to helper
              	$j.each( uploadedCoverFile2, function( key, value ) {
					post_list = post_list + value +',';
				});
              	var post_list_data = { 
                  	hash : $j( "#mango_post_list_data_hash" ).val(),
                    files : post_list,
                  	source : 'qtalbumseu'
                };
                $j.ajax({
					type: "POST",
					url: "https://filestack.qtalbums.ovh/token_to_db.php",
					headers: { 'Content-Type': 'application/x-www-form-urlencoded'},                  
					data: post_list_data,
					success: function(msg){
					console.log(msg);  
                 }
				});      
              	// end sending
  			},      
          	//onFileSelected: checkCoverImgSize,  
          	onClose: function(){
            },      
            uploadConfig: {
				tags: {
					"foo": "bar"
				},

			},   
        };
      	cover_picker = cover_filestack_client.picker(cover_options);
      
		$j(".mango-photopanel-cover-uploader-wrapper").show();
		$j("#mango-photopanel-cover-uploader-modal").show();
      	$j("#mango-photopanel-cover-uploader-step-1").show();
		$j("#mango-photopanel-cover-uploader-step-2").hide();            
		cover_picker.open();  
		window.scrollTo(0, 0);         
    });
  
  

    function closeCoverUploader(){
		$j(".mango-photopanel-cover-uploader-wrapper").hide();
		$j("#mango-photopanel-cover-uploader-modal").hide();
		$j("#mango-photopanel-cover-uploader-step-1").hide();            
      	$j("#mango-photopanel-cover-uploader-step-2").hide();     
		$j("#mango-photopanel-cover-uploader-step-3").hide();       
        $j("#mango-photopanel-cover-uploader-files").val('');
		$j("#mango-photopanel-cover-uploader-files-names").val('');       
		$j("#mango-cover-uploader-file").val('');              
      
      	cover_picker.close();      
       uploadedCoverFile = [];
       uploadedCoverFile2 = [];      

        $j( "#mango-photopanel-cover-uploader-preview-order .item" ).remove();        
        $j( "#mango-photopanel-cover-uploader-preview-slider .item" ).remove();  
        $j( "#mango-photopanel-cover-uploader-preview-slider2 .item" ).remove();        
    }
    function closeCoverPreview(){
		$j(".mango-photopanel-cover-uploader-wrapper2").hide();
		$j("#mango-photopanel-cover-uploader-modal2").hide();
		$j("#mango-photopanel-cover-uploader-step-4").hide();
    }  
    function finishCoverUploader(){
		$j(".mango-photopanel-cover-uploader-wrapper").hide();
		$j("#mango-photopanel-cover-uploader-modal").hide();
		$j("#mango-photopanel-cover-uploader-step-1").hide();            
      	$j("#mango-photopanel-cover-uploader-step-2").hide();       
		$j("#file-photopanel-cover-upload-show-btn").hide();    
		$j("#file-photopanel-cover-preview").show();        
      	cover_picker.close();
 uploadedCoverFile = [];
 uploadedCoverFile2 = [];   
   
      	$j( "#mango-photopanel-cover-uploader-preview-order .item" ).remove();        
        $j( "#mango-photopanel-cover-uploader-preview-slider .item" ).remove();       
		$j("#go-to-finish").hide();       
        $j("#message-no-uploader-files").hide();         
    }
  
    function uploadCoverFinished(upfiles){
//		console.log(upfiles);
		$j("#mango-photopanel-cover-uploader-step-1").hide();            
      	$j("#mango-photopanel-cover-uploader-step-2").show();                   
        //var albumSpreads = parseInt($("select#SingleOptionSelector-0").find(":selected").text());    
        $.each( upfiles, function( key, value ) {
            var temp_array = value.split('^');
            var filename = temp_array[0];              
            var handle = temp_array[1];            
            $j( "#mango-photopanel-cover-uploader-preview" ).append( '<img src="https://cdn.filestackcontent.com/resize=width:1800/' + handle + '" alt="" />');              		
            $j( "#mango-cover-uploader-file" ).val( $( "#mango-cover-uploader-file" ).val() +  handle + ';' );       
            $j( "#file-photopanel-cover-preview" ).append( '<img src="https://cdn.filestackcontent.com/resize=width:350/' + handle + '" alt="" style="width:350px;height:auto;margin:0 auto;"/>');        
            
            var image_width = $j( "#file-photopanel-cover-preview img" ).width();
          // recalculate after window resize
        });
    }
  
    function checkCoverImgSize(thisfile) {
        return new Promise(function (resolve, reject) {
          const minWidth = albumCoverWidthPx ;
          const minHeight = albumCoverHeightPx ;
          const blob = thisfile.originalFile;
          const url = window.URL.createObjectURL(blob);
          const img = new Image();
          img.src = url;

          img.onload = function () {
            window.URL.revokeObjectURL(url);
           // alert( this.naturalWidth +'---'+this.naturalHeight);
            if (this.naturalWidth < minWidth) {
              reject('Image quality ('+thisfile.filename+') is to poor (width). Minimal image dimentions are ' + minWidth + 'x' + minHeight + 'px');
              cover_picker.cancel();    
            }
            else if (this.naturalHeight < minHeight) {
              reject('Image quality ('+thisfile.filename+') is to poor. Minimal image dimentions are  ' + minWidth + 'x' + minHeight + 'px');
            }
            var ratio_natural = this.naturalWidth / this.naturalHeight;
            var ratio = minWidth/minHeight;            
            var ratio_min = ((minWidth/minHeight) - 0.01);
            var ratio_max = ((minWidth/minHeight) + 0.01);  
             
            if ( (ratio_natural.toFixed(2) < ratio_min.toFixed(2)) || (ratio_natural.toFixed(2) > ratio_max.toFixed(2)) ) {
              reject('WRONG DESIGN DIMENSIONS. You have uploaded '+this.naturalWidth+'x'+this.naturalHeight+'px while we need '+minWidth+'x'+minHeight+'px or bigger but with the same proportions.');
            }
            resolve();
          }
        });
    }
});
